var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('hold-key', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:press",
      value: _vm.handlePress,
      expression: "handlePress",
      arg: "press"
    }, {
      name: "hammer",
      rawName: "v-hammer:pressup",
      value: _vm.handleRelease,
      expression: "handleRelease",
      arg: "pressup"
    }, {
      name: "hammer",
      rawName: "v-hammer:pan",
      value: _vm.panstart,
      expression: "panstart",
      arg: "pan"
    }, {
      name: "hammer",
      rawName: "v-hammer:panstart",
      value: _vm.panstart,
      expression: "panstart",
      arg: "panstart"
    }, {
      name: "hammer",
      rawName: "v-hammer:panend",
      value: _vm.handlePan,
      expression: "handlePan",
      arg: "panend"
    }],
    attrs: {
      "name": _vm.name,
      "character": _vm.character,
      "row": _vm.row,
      "hold-hand": _vm.holdHand,
      "alt": _vm.alt,
      "shift": _vm.shift
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }